import { render, staticRenderFns } from "./channelManage.vue?vue&type=template&id=088bd921&scoped=true"
import script from "./channelManage.vue?vue&type=script&lang=js"
export * from "./channelManage.vue?vue&type=script&lang=js"
import style0 from "./channelManage.vue?vue&type=style&index=0&id=088bd921&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import style1 from "./channelManage.vue?vue&type=style&index=1&id=088bd921&prod&lang=css"
import style2 from "./channelManage.vue?vue&type=style&index=2&id=088bd921&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import style3 from "./channelManage.vue?vue&type=style&index=3&id=088bd921&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088bd921",
  null
  
)

export default component.exports